<template>
  <v-container
    class="align-content-start pa-0"
    fill-height
    fluid
  >
    <v-row>
      <v-col
        v-if="Investments.DescriptiveStatistics"
        cols="12"
        lg="4"
        md="4"
      >
        <descriptive-statistics :risk-analysis-id="accountId" />
      </v-col>

      <v-col
        v-if="Investments.DescriptiveStatistics"
        cols="12"
        lg="8"
        md="8"
      >
        <investments-maturity :risk-analysis-id="accountId" />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <investments-yields />
      </v-col>
      <v-col
        cols="12"
        md="8"
      >
        <investments-allocation />
      </v-col>
    </v-row>

    <!-- Dynamic Evolution Row -->
    <v-row>
      <v-col
        v-if="Investments.DynamicEvolution"
        cols="12"
      >
        <dynamic-evolution :risk-analysis-id="accountId" />
      </v-col>
    </v-row>

    <!-- Investment Concentration Row -->
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <yield :risk-analysis-id="accountId" />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <credit-quality :risk-analysis-id="accountId" />
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import API                               from '@/api/Api'
import { clone }                         from '@/lib/utils/helper'
import ALMInvestmentsResource from '@/api/resources/alm/ALMInvestmentsResource'
import DescriptiveStatistics from '@/theme/default/views/banking/alm/investments/blocks/DescriptiveStatistics.vue'
import AssetModel from '@/api/models/asset/AssetModel'
import InvestmentsMaturity from '@/theme/default/views/banking/alm/investments/blocks/InvestmentsMaturity.vue'
import DynamicEvolution from '@/theme/default/views/banking/alm/investments/blocks/DynamicEvolution.vue'
import CreditQuality from '@/theme/default/views/banking/alm/investments/blocks/CreditQuality.vue'
import InvestmentsAllocation from '@/theme/default/views/banking/alm/investments/blocks/InvestmentsAllocation.vue'
import InvestmentsYields from '@/theme/default/views/banking/alm/investments/blocks/InvestmentsYields.vue'
import Yield from '@/theme/default/views/banking/alm/investments/blocks/Yield.vue'

export default {
  name      : 'ALMInvestmentsPortfolio',
  components: {
    DescriptiveStatistics,
    InvestmentsMaturity,
    DynamicEvolution,
    CreditQuality,
    InvestmentsAllocation,
    InvestmentsYields,
    Yield
  },
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {
    selectedDate: {
      type   : String,
      default: ''
    }
  },
  dataStore: {
    appToolbarExtended: 'App.Config.AppToolbarExtended',

    Investments: 'ALM.Investments.Data',

    riskBaseCurrencyData: 'Risks.BaseCurrency.Data'
  },
  enums: {},
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('ALM.HeaderTitle'),
        disabled: true
      }]
    },
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    },

    selectedDate: {
      handler (newDate) {
        if (newDate && newDate.trim() !== '') {
          this.getData()
        }
      },
      immediate: true
    }
  },
  created () {
    if (this.selectedDate && this.selectedDate.trim() !== '') {
      this.getData()
    }
  },
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  destroyed () {},
  methods: {
    getData () {
      const params = this.selectedDate ? [this.accountId, this.selectedDate] : [this.accountId]
      API.Resource.ALM.GetALMInvestments(...params)
        .then(response => {
          this.handleResponse(response)
        })
        .catch(e => {
          this.handleResponse(e.response)
        })
        .finally(() => {})
    },
    handleResponse (response) {
      const data = API.responseData(response)?.findALMInfo || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.Investments = new ALMInvestmentsResource(o)

        this.$set(this.riskBaseCurrencyData, this.accountId, new AssetModel(o.baseCurrency ?? null))
      } else {
        this.Investments = null
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
  </script>

  <style scoped>

  </style>
